import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-m',
  templateUrl: './main-m.component.html',
  styleUrls: ['./main-m.component.scss']
})
export class MainMComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
